import script from "./AboutMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMain.vue?vue&type=script&setup=true&lang=js"

import "./AboutMain.vue?vue&type=style&index=0&id=0bec881b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bec881b"]])

export default __exports__